"use strict";
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var $dyn;
(function ($dyn) {
    var ax;
    (function (ax) {
        var taskGuide;
        (function (taskGuide) {
            /** Used in the task guide chain to update the Task Guide tooltip position when the element targeted by the Task Guide is scrolled or has its parent resized. */
            var ScrollComponent = /** @class */ (function () {
                function ScrollComponent(controller) {
                    var _this = this;
                    this.dispose = function () {
                        var e_1, _a;
                        _this._unsubscribeFromScrollEvents();
                        _this._unsubscribeFromResizeEvent();
                        if (_this.$shadowTarget) {
                            _this.$shadowTarget.remove();
                        }
                        try {
                            for (var _b = __values(_this.subscriptions), _c = _b.next(); !_c.done; _c = _b.next()) {
                                var subscription = _c.value;
                                if (subscription && subscription.dispose) {
                                    subscription.dispose();
                                }
                            }
                        }
                        catch (e_1_1) { e_1 = { error: e_1_1 }; }
                        finally {
                            try {
                                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                            }
                            finally { if (e_1) throw e_1.error; }
                        }
                        _this.subscriptions = null;
                    };
                    this._resizeHandler = function () {
                        if (_this._resizeTimeoutId) {
                            clearTimeout(_this._resizeTimeoutId);
                        }
                        _this._resizeTimeoutId = setTimeout(function () {
                            _this.output(_this._reposition(_this.input()));
                        }, 100);
                    };
                    this._scrollHandler = function () {
                        if (_this._scrollTimoutId) {
                            clearTimeout(_this._scrollTimoutId);
                        }
                        _this._scrollTimoutId = setTimeout(function () {
                            _this.output(_this._reposition(_this.input()));
                        }, 100);
                    };
                    this.subscriptions = [];
                    this.scrollParents = [];
                    this.$shadowTarget = null;
                    this._resizeTimeoutId = null;
                    this._scrollTimoutId = null;
                    // Shadow target determines the visible area of an element within its hiding parent
                    this._createShadowTarget();
                    this._subscribeToResizeEvent();
                }
                ScrollComponent.prototype.setup = function (input, output) {
                    var _this = this;
                    this.input = input;
                    this.output = output;
                    this.subscriptions.push($dyn.observe(input, function (guidedStepModel) {
                        _this._unsubscribeFromScrollEvents();
                        _this._buildScrollParents();
                        _this._subscribeToScrollEvents();
                        _this.output(_this._reposition(guidedStepModel));
                    }));
                    this.subscriptions.push($dyn.observe($dyn.ax.taskRecording.taskGuideRailsMode, function (railMode) {
                        if (railMode) {
                            _this.output(_this._reposition(_this.input()));
                        }
                    }));
                };
                ScrollComponent.prototype._unsubscribeFromScrollEvents = function () {
                    var e_2, _a;
                    try {
                        for (var _b = __values(this.scrollParents), _c = _b.next(); !_c.done; _c = _b.next()) {
                            var scrollParent = _c.value;
                            if (scrollParent) {
                                scrollParent.off("scroll", this._scrollHandler);
                            }
                        }
                    }
                    catch (e_2_1) { e_2 = { error: e_2_1 }; }
                    finally {
                        try {
                            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                        }
                        finally { if (e_2) throw e_2.error; }
                    }
                };
                ScrollComponent.prototype._subscribeToScrollEvents = function () {
                    var e_3, _a;
                    try {
                        for (var _b = __values(this.scrollParents), _c = _b.next(); !_c.done; _c = _b.next()) {
                            var scrollParent = _c.value;
                            if (scrollParent) {
                                scrollParent.scroll(this._scrollHandler);
                            }
                        }
                    }
                    catch (e_3_1) { e_3 = { error: e_3_1 }; }
                    finally {
                        try {
                            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                        }
                        finally { if (e_3) throw e_3.error; }
                    }
                };
                ScrollComponent.prototype._buildScrollParents = function () {
                    this.scrollParents = [];
                    var guidedStepOptions = this.input && this.input() && this.input().options;
                    if (guidedStepOptions && guidedStepOptions.target && guidedStepOptions.target.length && guidedStepOptions.target.scrollParent) {
                        var curentScrollParent = guidedStepOptions.target.scrollParent();
                        // as any is required because HTMLElement and document has not overlap
                        while (curentScrollParent && curentScrollParent.length && curentScrollParent[0] !== document) {
                            this.scrollParents.push(curentScrollParent);
                            curentScrollParent = curentScrollParent.scrollParent();
                        }
                    }
                };
                ScrollComponent.prototype._subscribeToResizeEvent = function () {
                    // On resize: the visible area of target can change.
                    // Update and set shadow element as a target if it is not set
                    $(window).on("resize", this._resizeHandler);
                };
                ScrollComponent.prototype._unsubscribeFromResizeEvent = function () {
                    // On resize: the visible area of target can change.
                    // Update and set shadow element as a target if it is not set
                    $(window).off("resize", this._resizeHandler);
                };
                ScrollComponent.prototype._createShadowTarget = function () {
                    var shadowTargetElement = document.createElement("div");
                    shadowTargetElement.style.position = "absolute";
                    shadowTargetElement.style.visibility = "hidden";
                    document.body.appendChild(shadowTargetElement);
                    this.$shadowTarget = $(shadowTargetElement);
                };
                ScrollComponent.prototype._resizeShadowTarget = function (rect) {
                    this.$shadowTarget[0].style.left = rect.left.toString() + "px";
                    this.$shadowTarget[0].style.top = rect.top.toString() + "px";
                    this.$shadowTarget[0].style.width = (rect.right - rect.left).toString() + "px";
                    this.$shadowTarget[0].style.height = (rect.bottom - rect.top).toString() + "px";
                };
                ScrollComponent.prototype._reposition = function (guidedStepModel) {
                    var e_4, _a;
                    if (!guidedStepModel) {
                        return;
                    }
                    var content = $.extend(true, {}, guidedStepModel.content);
                    var options = $.extend(true, {}, guidedStepModel.options);
                    if (!(this.scrollParents && options && options.target && options.target[0] && options.target[0].offsetWidth && content)) {
                        return { content: content, options: options };
                    }
                    var scrollParentsAndTarget = this.scrollParents.slice(0);
                    scrollParentsAndTarget.unshift(options.target);
                    var visibilityData = $dyn.ax.taskGuidesUtil.visibilityDataForNestedElements(scrollParentsAndTarget);
                    var target = options.target && $(options.target);
                    if (target && target[0] && $dyn.value($dyn.ax.taskRecording.taskGuideRailsMode) && !(visibilityData[0].isGloballyVisible())) {
                        // scroll target into view only if rails mode is on and target element is not globally visible
                        target[0].scrollIntoView();
                        visibilityData = $dyn.ax.taskGuidesUtil.visibilityDataForNestedElements(scrollParentsAndTarget);
                    }
                    var positionLabel;
                    var prevVisibilityData = null;
                    var i = 0;
                    try {
                        for (var visibilityData_1 = __values(visibilityData), visibilityData_1_1 = visibilityData_1.next(); !visibilityData_1_1.done; visibilityData_1_1 = visibilityData_1.next()) {
                            var currentVisibilityData = visibilityData_1_1.value;
                            if (i === 0 && currentVisibilityData.isGloballyVisible()) {
                                $.extend(options, {
                                    shadowTarget: null
                                });
                                break;
                            }
                            else if (i === 0 && currentVisibilityData.isGloballyPartiallyVisible()) {
                                this._resizeShadowTarget(currentVisibilityData.visibleArea);
                                $.extend(options, {
                                    shadowTarget: this.$shadowTarget
                                });
                                break;
                            }
                            else if (i !== 0 && currentVisibilityData.isGloballyVisible()) {
                                // Assuming previous visibility data is invisible
                                positionLabel = prevVisibilityData.verticalVisibilityLabel() + " " + prevVisibilityData.horizontalVisibilityLabel();
                                $.extend(options, {
                                    adjustMethod: "none",
                                    at: positionLabel,
                                    my: positionLabel,
                                    shadowTarget: null,
                                    target: currentVisibilityData.$element,
                                });
                                content.Title = $dyn.ax.taskGuidesUtil.qtipPositionToVerbal(positionLabel);
                                content.Example = "";
                                content.Note = "";
                                content.Step = "";
                                break;
                            }
                            else if (i !== 0 && currentVisibilityData.isGloballyPartiallyVisible()) {
                                positionLabel = prevVisibilityData.verticalVisibilityLabel() + " " + prevVisibilityData.horizontalVisibilityLabel();
                                this._resizeShadowTarget(currentVisibilityData.visibleArea);
                                $.extend(options, {
                                    adjustMethod: "none",
                                    at: positionLabel,
                                    my: positionLabel,
                                    shadowTarget: this.$shadowTarget,
                                    target: currentVisibilityData.$element,
                                });
                                content.Title = $dyn.ax.taskGuidesUtil.qtipPositionToVerbal(positionLabel);
                                content.Example = "";
                                content.Note = "";
                                content.Step = "";
                                break;
                            }
                            prevVisibilityData = currentVisibilityData;
                            i++;
                        }
                    }
                    catch (e_4_1) { e_4 = { error: e_4_1 }; }
                    finally {
                        try {
                            if (visibilityData_1_1 && !visibilityData_1_1.done && (_a = visibilityData_1.return)) _a.call(visibilityData_1);
                        }
                        finally { if (e_4) throw e_4.error; }
                    }
                    return { content: content, options: options };
                };
                /** This function is used only by tests */
                ScrollComponent.prototype.__forceRecalculate = function () {
                    this.output(this._reposition(this.input()));
                };
                return ScrollComponent;
            }());
            taskGuide.ScrollComponent = ScrollComponent;
        })(taskGuide = ax.taskGuide || (ax.taskGuide = {}));
    })(ax = $dyn.ax || ($dyn.ax = {}));
})($dyn || ($dyn = {}));

//# sourceMappingURL=ScrollComponent.js.map
